export function decodeMarkdownHtmlBreaks(markdown: string): string {
  if (!markdown.toLowerCase().includes('<br')) {
    return markdown
  }

  return markdown.replaceAll(/<br\s*\/?>/gi, '\n')
}
